import { render, staticRenderFns } from "./StudentsViewTabEnrollments.vue?vue&type=template&id=647638d4"
import script from "./StudentsViewTabEnrollments.vue?vue&type=script&lang=js"
export * from "./StudentsViewTabEnrollments.vue?vue&type=script&lang=js"
import style0 from "./StudentsViewTabEnrollments.vue?vue&type=style&index=0&id=647638d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports